import Helper from '@ember/component/helper'
import { service } from '@ember/service'
import { isUnsupportedStandardsSet } from 'teacher-ui-client/components/standards-set/unsupported-alert'
import type SessionService from 'teacher-ui-client/services/session'

interface Signature {
  Args: {
    Positional: unknown[]
    Named: object
  }
  Return: boolean
}

export class currentStandardsSetUnsupported extends Helper<Signature> {
  @service session!: SessionService

  compute(_positional: Signature['Args']['Positional'], _named: Signature['Args']['Named']) {
    const standardsSet = this.session.currentSchool.standardsSet
    if (standardsSet) {
      return isUnsupportedStandardsSet(standardsSet)
    }
    return false
  }
}
